<div [class.dark-theme]="true" class="fix-action-dialog">
	<div fxLayoutAlign="start center" style="font-size: 32px;font-weight: 900;color: #ffffff;">
		<mat-icon style="font-size: 32px;">play_arrow</mat-icon>
		<h2 class="card-title" style="padding-left: 8px;font-size: 1.2em;"><span translate>動画内容 入力画面</span></h2>
	</div>

	<mat-dialog-content>
		<div fxFlex="100" fxLayout="column">
			<form #form="ngForm" fxLayout="column wrap" novalidate style="padding: 32px 16px 16px 16px;background: #424242;border-radius: 1em;color: #ffffff;">
				<mat-form-field appearance="outline" fxFlex="100">
					<mat-label><span translate>詳細</span></mat-label>
					<textarea #autosize="cdkTextareaAutosize" #description="ngModel" [(ngModel)]="content.description" cdkAutosizeMaxRows="5" cdkAutosizeMinRows="1" cdkTextareaAutosize matInput maxlength="100" minlength="3"
							  name="description"
							  placeholder=""
							  required
					></textarea>
					<mat-hint><span translate>3文字以上100文字まで</span></mat-hint>
					<mat-error *ngIf="description.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
				</mat-form-field>
			</form>
		</div>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.lt-sm="space-between center" style="padding: 32px 0;color:#ffffff;font-size:10px;">
		<div fxFlex="40" fxLayoutAlign="center center" style="padding-top:32px;">
			<button (click)="onAccept()" [disabled]="form.invalid" color="primary" mat-raised-button><span translate>登録</span></button>
		</div>
		<div fxFlex="40" fxLayoutAlign="center center" style="padding-top:32px;">
			<button (click)="cancel()" color="warn" mat-dialog-close="" mat-raised-button><span translate>キャンセル</span></button>
		</div>
	</mat-dialog-actions>
</div>
